document.documentElement.classList.remove('no-js');
/* ugo.js — botones de compra del clon conectados a la app de pago contra entrega (Releasit) del comerciante */
(function () {
  var RSI_BTN = '._rsi-buy-now-button, #rsi_buy_now_button:not(.rsi_floating)';
  var RSI_MODAL = '#_rsi-cod-form-modal._rsi-cod-form-modal-open, dialog#rsi_form_wrapper[open]';
  var RSI_OFFER = '._rsi-quantity-offers-offer-container';
  var RSI_SEL = '_rsi-quantity-offers-selected';
  var syncing = false;

  function syncReleasit() {
    if (syncing || typeof window.UGO_SELECTED_IDX !== 'number') return;
    syncing = true;
    var t0 = Date.now(), done = false, mo = null, clicks = 0, last = 0;
    function finish() { done = true; syncing = false; if (mo) { mo.disconnect(); mo = null; } }
    function apply() {
      if (done) return true;
      if (!document.querySelector(RSI_MODAL)) return false;
      var offers = document.querySelectorAll(RSI_OFFER);
      if (!offers.length) return false;
      var el = offers[window.UGO_SELECTED_IDX | 0];
      if (!el) { finish(); return true; }
      if (el.classList.contains(RSI_SEL) || el.querySelector('.' + RSI_SEL)) { finish(); return true; }
      var target = el.querySelector('._rsi-quantity-offers-offer') || el;
      if (clicks < 6 && Date.now() - last > 250) { clicks++; last = Date.now(); try { target.click(); } catch (e) {} }
      return false;
    }
    if (apply()) return;
    if (window.MutationObserver) {
      mo = new MutationObserver(function () { if (apply()) return; if (Date.now() - t0 > 6000) finish(); });
      mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    (function poll() { if (done) return; if (apply()) return; if (Date.now() - t0 > 6000) { finish(); return; } setTimeout(poll, 150); })();
  }

  function releasitButton() {
    var h = document.getElementById('ugoReleasitHost');
    return h ? h.querySelector(RSI_BTN) : null;
  }

  window.ugoOpenReleasit = function () {
    var b = releasitButton();
    if (!b) return false;
    b.click();
    syncReleasit();
    return true;
  };

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var pack = e.target.closest('[data-ugo-pack]');
    if (pack) {
      var btn = e.target.closest('a, button');
      if (!btn || !pack.contains(btn)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.UGO_SELECTED_IDX = parseInt(pack.getAttribute('data-ugo-pack'), 10) || 0;
      if (!window.ugoOpenReleasit()) {
        var href = btn.getAttribute('href');
        if (href && href.indexOf('/cart/') === 0) window.location.href = href;
      }
      return;
    }
    var cta = e.target.closest('.ugo-cod-btn');
    var link = cta && e.target.closest('a[href^="#"]');
    var dest = null;
    try { dest = link && link.getAttribute('href').length > 1 ? document.querySelector(link.getAttribute('href')) : null; } catch (err) {}
    if (dest && dest.closest('.ugo-sec--ofertas')) {
      // como en la página original: el botón lleva a las ofertas y abre el formulario de pago contra entrega
      setTimeout(function () { window.ugoOpenReleasit(); }, 700);
    }
  }, true);
})();
